//
// SubscribedFolder.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "./Connection";

var SubscribedFolder = createModule("transport::SubscribedFolder", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    {
        FOLDER_UPDATED: 60118,
        FOLDER_DELETED: 60119,
    },
    {
        location: 7,
        connection: 1,
        isZombie: 2,
        uuid: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SubscribedFolder;
